import { createFileRoute } from '@tanstack/react-router';
import { QuoteEditorPage } from '@/features/finance';

/** A new quote (the editor without a saved quote). */
export const Route = createFileRoute('/_auth/o/$orgId/finance/quotes/new')({
  component: NewQuoteRoute,
});

function NewQuoteRoute() {
  const { orgId } = Route.useParams();
  return <QuoteEditorPage orgId={orgId} />;
}
